import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "addBranchOrgModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-700px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Салбар нэмэх", -1)
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-1" }, null, -1)
const _hoisted_9 = {
  class: "row",
  style: {"padding":"10px 20px 10px 10px"}
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Хадгалах ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Болих ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            class: "btn btn-sm btn-icon btn-active-color-primary",
            onMousedown: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clearField())),
            onMouseup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fillOrgCode())),
            "data-bs-dismiss": "modal"
          }, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "/web/media/icons/duotone/Navigation/Close.svg" })
            ])
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_form, {
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
            model: _ctx.modalForm,
            ref: "addbranchorgmodalref",
            "label-width": "220px",
            size: "mini",
            rules: _ctx.addBranchFormRules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "Төв салбарын код:",
                prop: "orgcode",
                "label-width": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.modalForm.orgcode,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modalForm.orgcode) = $event)),
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Салбарын нэр:",
                prop: "branchname",
                "label-width": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.modalForm.branchname,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalForm.branchname) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Салбарын код:",
                prop: "branchcode",
                "label-width": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.modalForm.branchcode,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modalForm.branchcode) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_row, {
            type: "flex",
            justify: "end"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "success",
                plain: "",
                size: "mini",
                class: "col-lg-3",
                loading: _ctx.addbranchbuttonloader,
                onClick: _cache[6] || (_cache[6] = ($event: any) => {
                _ctx.saveBranch();
                _ctx.formSubmit();
              })
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }, 8, ["loading"]),
              _createVNode(_component_el_button, {
                type: "info",
                plain: "",
                size: "mini",
                class: "col-lg-3",
                ref: "hidemodelbutton",
                onMousedown: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clearField())),
                onMouseup: _cache[8] || (_cache[8] = ($event: any) => (_ctx.fillOrgCode())),
                "data-bs-dismiss": "modal"
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }, 512)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}